import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=e1be6fc0&scoped=true"
import script from "./Consumables.vue?vue&type=script&lang=js"
export * from "./Consumables.vue?vue&type=script&lang=js"
import style0 from "./Consumables.vue?vue&type=style&index=0&id=e1be6fc0&prod&scoped=true&lang=css"
import style1 from "./Consumables.vue?vue&type=style&index=1&id=e1be6fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1be6fc0",
  null
  
)

export default component.exports